/* eslint-disable no-console */
import {ScriptStatus} from "./ScriptStatus";
import {newStatusPromise} from "./newStatusPromise";

export interface ScriptTracker {
  count(): number;
  monitor(script: HTMLScriptElement): HTMLScriptElement;
  statusOf(id: string): Promise<ScriptStatus>;
  reset(): void;
}

const promises: Record<string, Promise<ScriptStatus>> = {};

function scriptIds(): string[] {
  return Object.keys(promises);
}

const tracker: ScriptTracker = {
  count(): number {
    return scriptIds().length;
  },
  monitor(script: HTMLScriptElement): HTMLScriptElement {
    promises[script.id] = newStatusPromise(script);
    return script;
  },
  statusOf(id: string): Promise<ScriptStatus> {
    return promises[id];
  },
  reset() {
    // prettier-ignore
    scriptIds()
        .forEach(key => delete promises[key]);
  }
};

export function useScriptTracker(): ScriptTracker {
  return tracker;
}
